export let mondayAbbreviatedLowercase = "cj$5d";
export default {mondayAbbreviatedLowercase};